import { render, staticRenderFns } from "./NewPwaPanel.vue?vue&type=template&id=57f78be4&scoped=true"
import script from "./NewPwaPanel.vue?vue&type=script&lang=js"
export * from "./NewPwaPanel.vue?vue&type=script&lang=js"
import style0 from "./NewPwaPanel.vue?vue&type=style&index=0&id=57f78be4&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f78be4",
  null
  
)

export default component.exports